import React, { useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import InputMask from 'react-input-mask'

import ButtonPrimary from '~/components/Button/ButtonPrimary'
import ButtonSecondary from '~/components/Button/ButtonSecondary'

import api from '~/services/api'
import { validateCPF_CNPJ } from '~/services/utils'

import './Email.scss'

export default function RequestCPF({ companyToken, onHide }) {
  const history = useHistory()
  const { token: hasTokenInUrl } = useParams();
  const [cpf, setCpf] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [cpfNotValid, setCpfNotValid] = useState(false)
  const [error, setError] = useState(null)

  function handleCpfChange(event) {
    if (cpfNotValid) {
      setCpfNotValid(false)
    }
    setCpf(event.target.value.replace(/\D/g, ''))
  }

  function handleSubmit(event) {
    event.preventDefault()

    if (error) {
      setError(null)
    }

    const { valid } = validateCPF_CNPJ(cpf)

    if (!valid) {
      setCpfNotValid(true)
      return
    }

    setSubmitting(true)

    api.defaults.headers.common = {
      Authorization: `Bearer ${companyToken}`
    }

    api.post('/v1/check-companies', { cpf })
      .then(({ data }) => {
        let url = `/acessar/${data.token}`

        if (!hasTokenInUrl) {
          url += '?logoff=default'
        }

        history.push(url)
      })
      .catch(() => {
        setCpf('')
        setError('Usuário sem acesso a esta empresa')
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  return (
    <div className="login-email">
      <div className="text">
        <h1>Autenticação</h1>
        <p>Insira seu CPF</p>
        {error && <span className="error">{error}</span>}
      </div>

      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="cpf">CPF</label>
          <InputMask
            id="cpf"
            name="cpf"
            type="text"
            value={cpf}
            mask="999.999.999-99"
            maskPlaceholder=" "
            maskChar={null}
            onChange={handleCpfChange}
            autoFocus
            required
          />
          {cpfNotValid && (
            <div className="input-error">Seu CPF está incorreto.</div>
          )}
        </div>

        <div className="actions">
          <ButtonSecondary type="button" onClick={onHide}>
            Voltar
          </ButtonSecondary>
          <ButtonPrimary disabled={submitting}>
            {submitting ? 'Aguarde...' : 'OK'}
          </ButtonPrimary>
        </div>
      </form>
    </div>
  )
}
